import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ListResultDTO } from 'src/app/helpers/listResult.interface';
import { environment } from 'src/environments/environment';
import { TargetDTO, TargetFilters } from '../../models/target.model';

@Injectable({
  providedIn: "root"
})
export class LaravelTargetService {


  constructor(private httpClient: HttpClient) { }

  private get ROUTES() {
    return {
 
      list: environment.baseUrl + "/api/targets",
      show: environment.baseUrl + "/api/target",
      store: environment.baseUrl + "/api/target",
      destroy: environment.baseUrl + "/api/target",
  
    };
  }

  public list(page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: TargetFilters,
    includes?: string[]
  ): Observable<ListResultDTO<TargetDTO>> {
    let params = {};
    if (order) params["order"] = "" + order;
    if (direction) params["direction"] = "" + direction;
    if (includes) params["includes[]"] = includes;
    if (filters) {
      if (filters.search) params["search"] = "" + filters.search;
  }
    if (per_page) {
      params["per_page"] = "" + per_page;
      if (page) params["page"] = "" + page;
      return this.httpClient.get<ListResultDTO<TargetDTO>>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      });
    } else {
      return this.httpClient.get<TargetDTO[]>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      }).pipe(
        map(results => {
          return {
            data: results,
            total: results.length
          };
        })
      );
    }
  }


  public getTargetById(id: number): Observable<TargetDTO> {
    let params = { id: "" + id };
    return this.httpClient.get<TargetDTO>(this.ROUTES.show, {
      params: new HttpParams({
        fromObject: params
      })
    });

  }

  public upsert(target: TargetDTO): Observable<TargetDTO> {
    if (target.id) {
      return this.httpClient.put<TargetDTO>(`${this.ROUTES.store}`, { target });
    } else {
      return this.httpClient.post<TargetDTO>(`${this.ROUTES.store}`, { target });
    }
  }

  public delete(id: number): Observable<any> {
    let params = { id: "" + id };
    return this.httpClient.delete(this.ROUTES.destroy, {
      params: new HttpParams({
        fromObject: params
      })
    });
  }
}
